{
  "title": "Tin nhắn",
  "appBarTitle": "Hộp thoại đa kênh",
  "noPermission": "Bạn không có quyền xem hộp thư.",
  "list": {
    "empty": "Chưa có hội thoại nào.",
    "unknownContact": "Khách chưa rõ tên",
    "noPreview": "Chưa có tin nhắn",
    "search": "Tìm tên hoặc tin nhắn…",
    "loadMore": "Tải thêm"
  },
  "filters": {
    "panel": "Bộ lọc",
    "title": "Lọc hội thoại",
    "reset": "Đặt lại",
    "unread": "Chưa đọc",
    "closed": "Đã đóng",
    "hasContact": "Có SĐT/email",
    "mine": "Của tôi",
    "unassigned": "Chưa gán",
    "all": "Tất cả",
    "status": "Trạng thái",
    "channel": "Kênh",
    "selectChannel": "Chọn kênh",
    "allChannels": "Tất cả kênh",
    "page": "Trang / OA",
    "selectPage": "Chọn trang",
    "crm": "Gắn CRM",
    "selectCrm": "Chọn gắn CRM",
    "allCrm": "Tất cả",
    "crmUnlinked": "Chưa gắn",
    "selectAssignee": "Chọn nhân viên",
    "fromAd": "Từ quảng cáo",
    "adId": "Mã quảng cáo",
    "adIdPlaceholder": "Nhập mã quảng cáo",
    "lastMessageRange": "Tin cuối",
    "dateRangePlaceholder": "Chọn khoảng ngày",
    "leadStatus": "Trạng thái Lead",
    "selectLeadStatus": "Chọn trạng thái Lead",
    "allLeadStatuses": "Tất cả trạng thái"
  },
  "events": {
    "system": "Hệ thống",
    "assigned": "{{actor}} đã gán cho {{target}}",
    "unassigned": "{{actor}} đã bỏ gán",
    "lead_linked": "{{actor}} đã gắn Lead {{target}}",
    "lead_unlinked": "{{actor}} đã bỏ gắn Lead",
    "patient_linked": "{{actor}} đã gắn bệnh nhân {{target}}",
    "patient_unlinked": "{{actor}} đã bỏ gắn bệnh nhân",
    "closed": "{{actor}} đã đóng hội thoại",
    "reopened": "{{actor}} đã mở lại hội thoại",
    "reopenedByCustomer": "Hội thoại mở lại vì khách nhắn tin"
  },
  "thread": {
    "empty": "Chưa có tin nhắn trong hội thoại này.",
    "pick": "Chọn một hội thoại để xem tin nhắn.",
    "noText": "(không có nội dung)",
    "messageRemoved": "Tin nhắn đã bị xóa",
    "retry": "Thử lại",
    "ambiguousHint": "Có thể đã gửi — kiểm tra rồi thử lại để tránh tin trùng.",
    "retryAfterCheck": "Kiểm tra rồi thử lại",
    "retryPermanentHint": "Facebook/Pancake từ chối tệp này. Hãy gửi tệp khác.",
    "retryExhaustedHint": "Đã thử lại nhiều lần. Kiểm tra kết nối hoặc liên hệ quản trị.",
    "loadOlder": "Tải tin cũ hơn",
    "fetchingFromProvider": "Đang tải từ Pancake…",
    "openInbox": "Mở trong Hộp thư",
    "attachment": "Tệp đính kèm",
    "attachmentPending": "Đang tải tệp…",
    "attachmentFailed": "Không tải được tệp",
    "mediaPermalinkHint": "Media nằm trên Facebook/Instagram — mở trên nền tảng gốc.",
    "shareOpen": "Xem thêm",
    "shareAdId": "Ad ID: {{id}}",
    "mediaLoadFailed": "Không phát được — thử tải file.",
    "mediaUnsupported": "Loại tệp này chưa hỗ trợ xem trong hộp thư.",
    "viewer": {
      "close": "Đóng",
      "download": "Tải ảnh",
      "zoomIn": "Phóng to",
      "zoomOut": "Thu nhỏ",
      "rotateLeft": "Xoay trái",
      "rotateRight": "Xoay phải",
      "prev": "Ảnh trước",
      "next": "Ảnh sau",
      "counter": "{{current}} / {{total}}"
    },
    "kinds": {
      "image": "[Ảnh]",
      "video": "[Video]",
      "audio": "[Âm thanh]",
      "sticker": "[Nhãn dán]",
      "file": "[Tệp]"
    },
    "audio": {
      "play": "Phát",
      "pause": "Tạm dừng",
      "seek": "Tua tin nhắn thoại",
      "speed": "Tốc độ phát {{rate}} lần",
      "mute": "Tắt tiếng",
      "unmute": "Bật tiếng",
      "download": "Tải xuống"
    }
  },
  "status": {
    "pending": "Đang gửi",
    "sent": "Đã gửi",
    "delivered": "Đã nhận",
    "read": "Đã đọc",
    "failed": "Gửi lỗi",
    "ambiguous": "Chưa rõ đã gửi"
  },
  "composer": {
    "reply": "Trả lời",
    "note": "Ghi chú nội bộ",
    "placeholder": "Shift + Enter cho dòng mới. Gõ '/' để chọn câu trả lời soạn trước.",
    "placeholderNote": "Ghi chú nội bộ chỉ nhân viên thấy. Gõ '@' để nhắc đồng nghiệp.",
    "placeholderCaptionSeparate": "Chú thích sẽ gửi thành tin riêng, rồi tới tệp đính kèm.",
    "send": "Gửi",
    "sendWithShortcut": "Gửi ({{shortcut}})",
    "sendNote": "Lưu ghi chú",
    "sendNoteWithShortcut": "Lưu ghi chú ({{shortcut}})",
    "closed": "Hội thoại đã đóng. Mở lại để trả lời khách, hoặc viết ghi chú nội bộ.",
    "disabled": "Không thể gửi tin (thiếu quyền hoặc kênh chưa hỗ trợ).",
    "expand": "Mở rộng khung soạn",
    "collapse": "Thu nhỏ khung soạn",
    "tools": {
      "emoji": "Emoji",
      "attach": "Đính kèm tệp",
      "audio": "Ghi âm",
      "canned": "Câu trả lời soạn trước"
    },
    "fileTooLarge": "Tệp vượt quá giới hạn (ảnh/PDF: 10MB, video: 15MB).",
    "fileTypeUnsupported": "Chỉ gửi ảnh (JPEG, PNG, WebP, GIF), PDF hoặc video MP4.",
    "removeFile": "Gỡ tệp đính kèm",
    "fileReady": "{{name}}",
    "canned": {
      "empty": "Không tìm thấy câu trả lời soạn trước.",
      "hint": "Enter để chèn · Esc để đóng",
      "manage": "Quản lý"
    },
    "emoji": {
      "hint": "Chọn emoji để chèn · Esc để đóng"
    }
  },
  "channels": {
    "facebook": "Facebook",
    "instagram": "Instagram",
    "zalo": "Zalo",
    "tiktok": "TikTok",
    "whatsapp": "WhatsApp",
    "other": "Khác"
  },
  "context": {
    "selectConversation": "Chọn hội thoại để xem Lead / bệnh nhân.",
    "title": "Chi tiết",
    "linkedPrefix": "Đã gắn",
    "unlinkedHint": "Chưa gắn CRM",
    "channel": "Kênh",
    "page": "Trang",
    "lead": "Lead",
    "patient": "Bệnh nhân",
    "assignee": "Người phụ trách",
    "unassigned": "Chưa gán",
    "notLinkedLead": "Chưa gắn Lead.",
    "notLinkedPatient": "Chưa gắn bệnh nhân.",
    "unlink": "Bỏ gắn",
    "change": "Đổi",
    "phone": "SĐT",
    "email": "Email",
    "copy": "Sao chép",
    "copied": "Đã sao chép",
    "copyFailed": "Không sao chép được",
    "toggle": "Thông tin CRM",
    "searchLead": "Gắn Lead có sẵn",
    "searchPatient": "Gắn bệnh nhân",
    "searchPatientOptional": "Gắn bệnh nhân (tuỳ chọn)",
    "leadPlaceholder": "Chọn Lead",
    "patientPlaceholder": "Chọn bệnh nhân",
    "createLead": "Tạo Lead",
    "createLeadTitle": "Tạo Lead từ hội thoại",
    "createLeadName": "Tên",
    "createLeadPhone": "Số điện thoại",
    "createLeadPhonePlaceholder": "Ví dụ: 0901234567",
    "createLeadEmail": "Email",
    "createLeadCancel": "Hủy",
    "suggestion": {
      "title": "Phát hiện thông tin liên hệ",
      "phoneChat": "SĐT trong chat",
      "emailChat": "Email trong chat",
      "phoneChannel": "SĐT từ kênh",
      "emailChannel": "Email từ kênh",
      "linkMatch": "Gắn {{name}}",
      "dismiss": "Bỏ qua"
    },
    "assignUser": "Gán nhân viên",
    "assignPlaceholder": "Chọn người phụ trách",
    "openLead": "Mở Lead",
    "openPatient": "Mở bệnh nhân",
    "status": "Trạng thái",
    "statusOpen": "Đang mở",
    "createdAt": "Tạo lúc",
    "ads": "Nguồn quảng cáo",
    "adsNone": "Không từ quảng cáo",
    "sections": {
      "lead": "Lead",
      "patient": "Bệnh nhân",
      "appointments": "Lịch hẹn",
      "conversation": "Hội thoại",
      "attachments": "Tệp đính kèm"
    },
    "bookAppointment": "Đặt lịch",
    "needCrmLink": "Gắn Lead hoặc bệnh nhân trước khi đặt lịch.",
    "emptyUpcoming": "Chưa có lịch sắp tới.",
    "attachments": {
      "media": "MEDIA",
      "files": "FILE",
      "viewAll": "Xem tất cả ›"
    }
  },
  "actions": {
    "sync": "Đồng bộ lại",
    "close": "Đóng",
    "reopen": "Mở lại"
  },
  "toasts": {
    "sent": "Đã gửi tin nhắn",
    "sendFailed": "Gửi tin nhắn thất bại",
    "notePosted": "Đã lưu ghi chú",
    "noteFailed": "Không lưu được ghi chú",
    "closed": "Đã đóng hội thoại",
    "closeFailed": "Không đóng được hội thoại",
    "reopened": "Đã mở lại hội thoại",
    "reopenFailed": "Không mở lại được hội thoại",
    "retried": "Đã thử gửi lại",
    "retryFailed": "Thử gửi lại thất bại",
    "linked": "Đã cập nhật liên kết CRM",
    "linkFailed": "Không cập nhật được liên kết",
    "leadCreated": "Đã tạo Lead từ hội thoại",
    "leadCreateFailed": "Không tạo được Lead",
    "suggestionDismissed": "Đã bỏ qua gợi ý",
    "suggestionDismissFailed": "Không bỏ qua được gợi ý",
    "alreadyLinked": "Hội thoại đã gắn Lead hoặc bệnh nhân",
    "assigned": "Đã cập nhật người phụ trách",
    "assignFailed": "Không gán được người phụ trách",
    "synced": "Đồng bộ xong ({{count}} tin mới)",
    "syncEnqueued": "Đã xếp hàng đồng bộ — tin nhắn sẽ cập nhật trong giây lát",
    "syncFailed": "Đồng bộ thất bại",
    "syncInProgress": "Đang đồng bộ rồi, thử lại sau"
  },
  "canned": {
    "title": "Quản lý câu trả lời nhanh",
    "noPermission": "Bạn không có quyền quản lý câu trả lời soạn trước.",
    "loadError": "Không tải được danh sách câu trả lời soạn trước.",
    "search": "Tìm shortcode hoặc nội dung…",
    "add": "Thêm câu trả lời",
    "edit": "Sửa câu trả lời",
    "empty": "Chưa có câu trả lời soạn trước.",
    "active": "Đang dùng",
    "inactive": "Đã tắt",
    "systemLocked": "Mẫu hệ thống chỉ tắt được, không xóa.",
    "moreActions": "Thêm thao tác",
    "history": "Lịch sử",
    "historyTitle": "Lịch sử",
    "historyEmpty": "Chưa có hoạt động nào được ghi nhận.",
    "deleteConfirm": "Xóa câu trả lời /{{shortcode}}?",
    "columns": {
      "shortcode": "Shortcode",
      "title": "Tiêu đề",
      "content": "Nội dung",
      "status": "Trạng thái"
    },
    "fields": {
      "shortcode": "Shortcode",
      "shortcodeHint": "Chữ thường, số, gạch ngang hoặc gạch dưới. Gõ /shortcode trong hộp thư.",
      "title": "Tiêu đề",
      "content": "Nội dung",
      "required": "Trường này bắt buộc",
      "placeholders": {
        "shortcode": "chao-khach",
        "title": "Lời chào",
        "content": "Xin chào, phòng khám có thể hỗ trợ gì cho anh/chị?"
      }
    },
    "toasts": {
      "created": "Đã thêm câu trả lời soạn trước",
      "createFailed": "Không thêm được câu trả lời",
      "updated": "Đã cập nhật câu trả lời soạn trước",
      "updateFailed": "Không cập nhật được câu trả lời",
      "deleted": "Đã xóa câu trả lời soạn trước",
      "deleteFailed": "Không xóa được câu trả lời",
      "enabled": "Đã bật câu trả lời",
      "disabled": "Đã tắt câu trả lời"
    },
    "errors": {
      "duplicate": "Shortcode này đã được dùng.",
      "shortcode": "Shortcode không hợp lệ.",
      "limit": "Đã đạt giới hạn số câu trả lời soạn trước.",
      "systemDelete": "Không xóa được mẫu hệ thống. Hãy tắt mẫu đó."
    }
  },
  "profilePanel": {
    "noPermission": "Bạn không có quyền xem tin nhắn.",
    "emptyTitle": "Chưa gắn hội thoại",
    "emptyDescriptionPatient": "Hội thoại Facebook, Instagram hoặc Zalo gắn với bệnh nhân này sẽ hiện ở đây. Gắn hội thoại từ hộp thư hoặc tìm theo tên / số điện thoại.",
    "emptyDescriptionLead": "Hội thoại Facebook, Instagram hoặc Zalo gắn với lead này sẽ hiện ở đây. Gắn hội thoại từ hộp thư hoặc tìm theo tên / số điện thoại.",
    "link": "Gắn hội thoại",
    "linkTitlePatient": "Gắn hội thoại với bệnh nhân",
    "linkTitleLead": "Gắn hội thoại với lead",
    "linkSearch": "Tìm theo tên hoặc số điện thoại…",
    "linkEmpty": "Không tìm thấy hội thoại chưa gắn.",
    "linkHint": "Chỉ hiện hội thoại chưa gắn Lead hoặc bệnh nhân.",
    "composerReadOnly": "Hồ sơ đã lưu trữ — chỉ xem tin nhắn.",
    "pick": "Chọn hội thoại phía trên để xem tin nhắn.",
    "title": "Tin nhắn",
    "collapse": "Ẩn tin nhắn",
    "expand": "Tin nhắn"
  }
}
